import React, { useState, useEffect, useRef, useContext } from "react";
import { Form, Input, Select, InputNumber } from "antd";
const EditableContext = React.createContext();
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    column,
    editList,
    ...restProps
}) => {

    const [editing, setEditing] = useState(false);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async e => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    
    const onKeyDown = async event => {
        if (event.keyCode === 40) {
            let findIndex = editList.findIndex(item => item.key == record.key)
            if (findIndex === editList.length - 1) {
                return false
            }
            let node = event.target
            let trParentNode = node.closest("tr")
            let findInd = column.findIndex(item=>item.dataIndex==dataIndex)
            trParentNode.nextSibling.children[findInd].children[0].click()
        }
        if (event.keyCode === 38) {
            let findIndex = editList.findIndex(item => item.key == record.key)
            if (findIndex === 0) {
                return false
            }
            let node = event.target
            let trParentNode = node.closest("tr")
            let findInd = column.findIndex(item=>item.dataIndex==dataIndex)
            trParentNode.previousSibling.children[findInd].children[0].click()
        }
        // console.log(event.keyCode)
    }
    const onFocus = ()=>{
        inputRef.current.select()
    }
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <>
                {
                    (() => {
                        if (dataIndex === "Num") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                    { type: 'number', message: `当前不是一个有效数字`, transform: (value) => { Number(value) } }
                                ]}
                            >
                                <Input
                                    ref={inputRef}
                                    onBlur={save}
                                    onKeyDown={onKeyDown}
                                    onFocus={onFocus}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        }
                    }
                    )()
                }
            </>
        ) : (
                <div
                    className="editable-cell-value-wrap"
                    style={{
                        paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                >
                    {children}
                </div>
            );
    }

    return <td {...restProps}>{childNode}</td>;
};
export {
    EditableRow,
    EditableCell
}